export default __webpack_public_path__ + "static/media/assistencia-banner-site.95ce1821.png";